import { get, post } from '$fetch'

/**
 * 获取首屏数据
 * @param {String} cid 车源id
 * @param {String} city_name 城市
 * @param {String} caller 调用端，固定值pc
 * @returns
 */
export const getFirstScreenData = params => get('/lurker/v1/detail/firstpagepc', params, { isFormData: false, isAutoMsg: false })

/**
* 获取非首屏数据
* @param {String} type 数据类型，固定值detail
* @param {String} cid 车源id
* @returns
*/
export const getOtherScreenData = params => get('/lurker/v1/detail/anotherpagepc', params, { isFormData: false, isAutoMsg: false })

/**
 * 车辆收藏确认
 * @param {String} token token
 * @param {String} carid 车源id
 */
export const favoriteConfirm = params => get('/lurker/v1/favorite/confirm', params, {
  isLoading: true
})

/**
 * 车辆收藏
 * @param {String} token token
 * @param {String} carid 车源id
 */
export const favoriteAdd = params => post('/lurker/v1/favorite/add', params, {
  isLoading: true
})

/**
 * 车辆取消收藏
 * @param {String} token token
 * @param {String} carid 车源id
 */
export const favoriteRemove = params => get('/lurker/v1/favorite/remove', params, {
  isLoading: true
})

export const abtestInit = (params = {}) => get('/lurker/v1/abtest', params, { isLoading: false })

/**
 * 获取服务费接口
 * @param {*} params
 * @returns
 */
export const serviceFee = (params = {}) => get('/lurker/v1/detail/servicepriceconfig', params, { isLoading: false })
